var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0072,
    cy: 40.0072,
    r: 40.0072,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3249 41.0626H51.8875L52.5547 42.1846C52.8607 42.644 52.8607 43.2424 52.5547 43.7018L52.1297 44.3351C51.8576 44.7434 51.8251 45.2662 52.0447 45.705L52.753 47.1216C52.9457 47.5069 52.9457 47.9604 52.753 48.3456L51.9441 49.9621C51.7823 50.2866 51.7558 50.6621 51.8705 51.0061L52.107 51.7145C52.2718 52.2059 52.1439 52.7482 51.777 53.1141L49.7625 54.8751H40.1716C39.6499 54.8749 39.133 54.9745 38.6487 55.1683L35.957 55.9376",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3867 47.7306L30.9796 46.008C31.5494 45.7929 32.0314 45.3941 32.3495 44.8746L35.3032 38.0435C35.6133 37.5392 36.029 37.1081 36.5216 36.7798L37.5501 36.0927",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1476 40.2904L35.9574 24.9451C35.9248 24.7233 35.9904 24.4984 36.1371 24.3289C36.2837 24.1594 36.4969 24.0622 36.721 24.0625H47.4196",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7064 41.0624L41.5079 29.1496C41.4865 28.9491 41.5516 28.749 41.6868 28.5995C41.8221 28.4499 42.0146 28.3651 42.2162 28.3662H51.9912C52.1996 28.3637 52.3985 28.4531 52.535 28.6106C52.6715 28.7681 52.7317 28.9777 52.6996 29.1836L50.9174 41.0624",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8516 35.2131C47.1442 35.2132 47.3818 35.4499 47.3828 35.7425C47.3838 36.0352 47.148 36.2735 46.8553 36.2756C46.5626 36.2777 46.3234 36.0427 46.3203 35.7501C46.3203 35.4567 46.5582 35.2188 46.8516 35.2188",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustIcon);
export default __webpack_public_path__ + "static/media/trust-icon.61728947d5073a20ea8946dd05429d78.svg";
export { ForwardRef as ReactComponent };